import { render, staticRenderFns } from "./PageContent.vue?vue&type=template&id=5b866a9a&scoped=true&"
import script from "./PageContent.vue?vue&type=script&lang=js&"
export * from "./PageContent.vue?vue&type=script&lang=js&"
import style0 from "./PageContent.vue?vue&type=style&index=0&id=5b866a9a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b866a9a",
  null
  
)

export default component.exports